// extracted by mini-css-extract-plugin
module.exports = {"works-with":"landing_page__works-with___1ODzN"};